import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import ReadScenariosResponse from 'features/scenario/domain/models/read-scenarios-response';

const scenarioBaseUrl = '/api/v1/scenario';

enum QueryPaths {
  ReadScenarios = 'ReadScenarios',
}

const readScenarios = async (axiosInstance: AxiosInstance): Promise<ReadScenariosResponse> => {
  const response = await axiosInstance.get(`${scenarioBaseUrl}/${QueryPaths.ReadScenarios}`);
  return response.data;
};

export const useReadScenarios = () => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [QueryPaths.ReadScenarios],
    queryFn: () => readScenarios(authenticatedInstance),
  });
};
